<template>
  <div
    class="w-100 h-100"
    id="videoControls"
  >
    <VideoJS
      ref="refVideoJS"
      style="width:100% !important; aspect-ratio:16/9 !important;height:auto;"
      :videojsid="videojsid"
      :autoplay="autoplay"
      :onVideoJSMounted="onVideoJSMounted"
      :onVideoError="onVideoError"
      :onVideoReady="onVideoReady"
      :onVideoEnded="onVideoEnded"
      :playerStatusChange="playerStatusChange"
      :onVideoTimeupdate="onVideoTimeupdate"
      :onVideoDurationchange="onVideoDurationchange"
      :onVideoFullscreenchange="onVideoFullscreenchange"
      :onVideoCanplaythrough="onVideoCanplaythrough"
      :controls="false"
    />
  </div>
  <teleport
    :to="`#${videojsid}`"
    v-if="isTeleport"
  >
    <transition>
      <div
        class="custom-player-controls"
        v-show="isShow"
      >
        <!-- 大播放-->
        <div
          class="position-absolute center-vertical-absolute center-horizontal-absolute "
          id="btn-big-play"
          style="opacity: 0.7;"
        >
          <a
            class="btn btn-danger mt-n4 rounded-pill player d-flex align-items-center justify-content-center"
            @click="onPlayStatusChange"
          >                
            <template v-if="!isPlaying">
              <i class="fas fa-play" />
            </template> 
            <template v-if="isPlaying">
              <i class="fas fa-pause" />
            </template> 
          </a>  
        </div>                             
        <!-- 上一課 沒有前一課就不出現-->
        <template v-if="showPreviousVideo">
          <div
            class="position-absolute left-0 center-vertical-absolute"
            @click="previousVideo"
            id="btn-previous-video"
          >                       
            <a
              class="text-neutral videoicon py-3  px-2 bg-gray-800 rounded-right"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="前一知識點"
            >
              <i class="fa-solid fa-backward-step heart" />
            </a>  
          </div> 
        </template>

        <!-- 下一課 沒有前一課就不出現-->
        <template v-if="showNextVideo">
          <div
            class="position-absolute right-0 center-vertical-absolute"
            @click="nextVideo"
            id="btn-next-video"
          >                       
            <a
              class="text-neutral videoicon py-3  px-2 bg-gray-800 rounded-left"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="下一知識點"
            >
              <i class="fa-solid fa-forward-step heart" />
            </a>
          </div>
        </template>

        <div
          class="col-12 bg-gray-800 position-absolute bottom-0"
          id="controls-footer"
        >
          <div class="input-slider-container w-100">
            <div 
              ref="refVideoSlider" 
              id="videoSlider"
              class="input-slider" 
              data-range-value-min="0" 
              data-range-value-max="100"
            />
            <!-- Input slider values -->
            <div class="row mt-3 d-none">
              <div class="col-6">
                <span
                  class="range-slider-value"
                  data-range-value-low="0"
                />
              </div>
            </div>
          </div>
          <div class="row ">                                      
            <div class="col-7 px-2 px-md-3">
              <div class="d-flex align-items-center h-100">
                <!-- 播放-->
                <template v-if="!isPlaying">
                  <a
                    class="mx-2 text-neutral videoicon py-2"
                    @click="onPlayStatusChange"
                  >
                    <i class="fas fa-play" />
                  </a>      
                </template>                                
                <!-- 暫停-->
                <template v-if="isPlaying">
                  <a
                    class="mx-2 text-neutral videoicon"
                    @click="onPlayStatusChange"
                  > 
                    <i class="fas fa-pause" />
                  </a>  
                </template> 
                <!-- 進度/長度-->
                <p class="mb-0 text-white mx-2 videofontlh">
                  <span>{{ currentTimeMMSS }}</span>
                  <span class="mx-1">/</span>
                  <span>{{ totalTimeMMSS }}</span>
                </p>
                <!--音量--> 
                <div class="dropup">
                  <div class="d-flex align-items-center h-100">
                    <template v-if="!isMuted">
                      <a
                        class="mx-2 text-neutral videoicon"
                        @click="onChangeMuted"
                      > 
                        <i class="fa-solid fa-volume-high" />
                      </a>
                    </template>
                    <template v-if="isMuted">
                      <!--音量到0切換靜音圖示-->
                      <a
                        class="mx-2 text-neutral videoicon"
                        @click="onChangeMuted"
                      > 
                        <i class="fa-solid fa-volume-xmark" />
                      </a>
                    </template>
                  </div>
                  <!-- 手機版只有點擊切換靜音-->
                  <template v-if="!inapp.isMobile">
                    <div class=" ">
                      <div class="d-none d-md-block ">
                        <div class="dropup-content valuec rounded-lg">
                          <div class="input-slider-container w-100 py-1">
                            <div
                              ref="refVolumeSlider" 
                              id = "volumeSlider"
                              class="input-slider" 
                              data-range-value-min="0.0" 
                              data-range-value-max="1.0"
                            />
                            <div class="row mt-3 d-none">
                              <div class="col-6">
                                <span
                                  class="range-slider-value"
                                  data-range-value-low="0.5"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> 
                  </template>
                </div> 
              </div>                               
            </div>
            <div class="col-5 px-2 px-md-3">
              <div class="d-flex align-items-center justify-content-end h-100">
                <div> 
                  <img class="px-1" :style="'width: 80px;'" src="@/assets/img/crstreamlogo.png">
                </div>
                <!-- 播放速度-->  
                <div class="dropup mx-2">
                  <button class="btn btn-sm btn-white px-1 py-0 videofont my-2">
                    {{ playbackRate }}x
                  </button>
                  <div
                    class="dropup-content rounded-lg videofont videofontlh"
                    style="overflow: hidden;"
                  >
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(0.5)"
                    >0.5x
                      <template v-if="playbackRate == 0.5">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a>
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(0.75)"
                    >0.75x
                      <template v-if="playbackRate == 0.75">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a>
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(1.0)"
                    >1x
                      <template v-if="playbackRate == 1.0">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a>
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(1.25)"
                    >1.25x
                      <template v-if="playbackRate == 1.25">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a>
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(1.5)"
                    >1.5x
                      <template v-if="playbackRate == 1.5">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a> 
                    <a
                      class="d-flex justify-content-between align-items-center"
                      @click="onChangePlaybackRate(2.0)"
                    >2x
                      <template v-if="playbackRate == 2.0">
                        <i class="fa-solid fa-check text-danger" />
                      </template>
                    </a>
                  </div>
                </div>
                <!-- 解析度-->  
                <div class="dropup mx-2">
                  <button class="btn text-white my-2 border-0 p-0 videoicon">
                    <span class="fa-solid fa-gear" />
                  </button>
                  <div
                    class="dropup-content rounded-lg videofontlh"
                    style="overflow: hidden;"
                  >
                    <template v-for="(item, index) in videoResolutionList">
                      <a
                        class="d-flex justify-content-between align-items-center"
                        @click="onChangeResolution(item)"
                      >{{ item.videoResolution }}
                        <template v-if="videoResolution == item.videoResolution">
                          <i class="fa-solid fa-check text-danger" />
                        </template>
                      </a>
                    </template>
                  </div>
                </div>   
                <!-- 縮小-->
                <template v-if="isFullScreen">
                  <a
                    class="mx-2  text-neutral videoicon"
                    @click="onFullscreenchange"
                  > <i class="fas fa-compress" /></a>  
                </template>
                <!-- 全螢幕-->
                <template v-if="!isFullScreen">
                  <a
                    class="mx-2 text-neutral videoicon"
                    @click="onFullscreenchange"
                  > <i class="fas fa-expand" /></a>  
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>


<script >
import { ref, toRefs, reactive , watch , onMounted, onUnmounted, nextTick } from 'vue';
import NoUiSlider from 'nouislider';
import { VideoJS } from '@/components/VideoPlayer' ;
import InApp from 'detect-inapp';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'VideoControls',
  components: {
    VideoJS,
  },
  props: {
    videosrc: {
      type: String,
      required:true
    },
    poster: {
      type: String,
      required:true
    },
    autoplay: {
      type: Boolean,
      required:true
    },      
    videoResolutionList: {
      type: Array,
      required:true
    },
    nextVideo: {
      type: Function,
      required:true
    },
    previousVideo: {
      type: Function,
      required:true
    },
    showPreviousVideo: {
      type: Boolean,
      required:true
    },
    showNextVideo: {
      type: Boolean,
      required:true
    },
    changeResolution: {
      type: Function,
      required:true
    },
    videoTimeupdate: {
      type: Function,
      required:true
    },
    ready: {
      type: Function,
      required:true
    },
    canplaythrough: {
      type: Function,
      required:true
    },
    error: {
      type: Function,
      required:true
    },
    end: {
      type: Function,
      required:true
    },        
  },
  emits: [
  ],
  setup(props,{emit}) { 
    // props
    const { videosrc, poster, autoplay, ready, error, end, videoTimeupdate, videoResolutionList, nextVideo, previousVideo, showPreviousVideo, showNextVideo, changeResolution, canplaythrough } = toRefs(props); 
    // enum    
    // const data      
    const refVideoJS = ref();
    const refVideoSlider = ref();
    const refVolumeSlider = ref();
    const isTeleport = ref(false);
    const isPlaying = ref(false); 
    const isFullPlaying = ref();       
    const isVideoSlider = ref(false);  
    const isMuted = ref(false);
    const isFullScreen = ref(false);
    const totalTime = ref(0);   
    const totalTimeMMSS = ref('00:00');   
    const currentTime = ref(0);   
    const currentTimeMMSS = ref('00:00'); 
    const volume = ref(0.5); 
    const mutedVolume = ref(0.5); 
    const playbackRate = ref(1.0);
    const inapp = ref();   
    const videoResolution = ref('');  
    const videojsid = ref('videojsid');
    const isShow = ref(true);
    const videoControlsTimeout = ref();
    const lastcurrenttime = ref();
      
    watch(currentTime, (newValue)=>{
      //更新影片時間進度條
      if(refVideoSlider.value){
        if(currentTime.value != null && currentTime.value != undefined){
          refVideoSlider.value.noUiSlider.set(Math.floor(currentTime.value));
        }
      }
    });
    watch(videosrc, (newValue)=>{
      //更新影片
      if(refVideoJS.value){   
        nextTick(() => {
          $('.tooltip').hide();
          // 初始化Tip ==== End ====
        });  
        refVideoJS.value.setVideoSrc(videosrc.value);
        // console.log(videosrc.value);
      }       
    });
    watch(poster, (newValue)=>{
      //更新影片預覽圖
      if(refVideoJS.value){
        refVideoJS.value.setPoster(poster.value);
      }       
    });   
      

    onMounted(async () => {
      const useragent = navigator.userAgent || navigator.vendor || window.opera;

      inapp.value = new InApp(useragent);
      nextTick(() => {
        // 自定義滑鼠移動結束事件
        (function ($) {
          let timeout;

          $(document).on('mousemove', function (event) {
            if (timeout !== undefined) {
              window.clearTimeout(timeout);
            }
            timeout = window.setTimeout(function () {
              // trigger the new event on event.target, so that it can bubble appropriately
              $(event.target).trigger('mousemoveend');
            }, 1000);
          });
        })(jQuery);
      });
    });  
    onUnmounted(async () => {
    });  

    function onVideoJSMounted(){
      initVideoJS();        
      // 搬移控制器到VideoJS裡面
      isTeleport.value = true;
      nextTick(() => {
        // 初始化Tip ==== Strat ====
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl);
        });

        if(tooltipList && tooltipList.length > 0){
          for(let i = 0; i < tooltipList.length; i++){
            tooltipList[i].config.placement = 'bottom';
          }
        }
        $(document.querySelectorAll('[data-bs-toggle="tooltip"]')).on('show.bs.tooltip', function() {
          if(inapp.value.isMobile){
            setTimeout(()=>{
              $('.tooltip').not(this).hide();
            },1500);
          }
        });
        // 初始化Tip ==== End ====

        // 初始化時間進度條 ==== Strat ====
        NoUiSlider.create(refVideoSlider.value, {
          animate: false,
          start: [0],
          connect: [true, false],
          range: {
            'min': [0],
            'max': [100]
          }
        });
        if(refVideoSlider.value){
          let videoSlider = document.getElementById('videoSlider');
          let handler = videoSlider.getElementsByClassName('noUi-handle noUi-handle-lower');

          refVideoSlider.value.noUiSlider.on('slide', function (res) {
            isVideoSlider.value = true;
            onVideoTimeupdate(res[0], true);
          });
          refVideoSlider.value.noUiSlider.on('change', function (res) {
            if(refVideoJS.value){
              refVideoJS.value.setPlaySeekToTime(currentTime.value);
            }
            isVideoSlider.value = false;
          });
          videoSlider.addEventListener('mouseenter',function() {
            if(handler && handler.length > 0 ){
             for(const [k,v] of Object.entries(handler)){
               v.style.marginTop = '-4px';
             }
            }
          });
          videoSlider.addEventListener('mouseout',function() {
            if(handler && handler.length > 0 ){
             for(const [k,v] of Object.entries(handler)){
               v.style.marginTop = '-6px';
             }
            }
          });
        }
        // 初始化時間進度條 ==== End ====
        
        // 初始化音量進度條 ==== Strat ====
        if(!inapp.value.isMobile){
          NoUiSlider.create(refVolumeSlider.value, {
            start: [0.5],
            connect: [true, false],
            range: {
              'min': [0.0],
              'max': [1.0]
            }
          });
          if(refVolumeSlider.value){
            let volumeSlider = document.getElementById('volumeSlider');
            let handler = volumeSlider.getElementsByClassName('noUi-handle noUi-handle-lower');
            // console.log(volumeSlider)

            refVolumeSlider.value.noUiSlider.on('slide', function (res) {
              mutedVolume.value = res[0];
              volume.value = res[0];
              if(refVideoJS.value){
                refVideoJS.value.setVolume(res[0]);
                if(res[0] <= 0){
                  refVideoJS.value.setMuted(true);
                  isMuted.value = true;
                }else{
                  refVideoJS.value.setMuted(false);
                  isMuted.value = false;
                }
              }
            });
            volumeSlider.addEventListener('mouseenter',function() {
              console.log('mouseenter');
              if(handler && handler.length > 0 ){
                for(const [k,v] of Object.entries(handler)){
                  v.style.marginTop = '-4px';
                }
              }
            });
            volumeSlider.addEventListener('mouseout',function() {
              console.log('mouseenter');
              if(handler && handler.length > 0 ){
                for(const [k,v] of Object.entries(handler)){
                  v.style.marginTop = '-6px';
                }
              }
            });
          }
        }
        // 初始化音量進度條 ==== End ====
            
        // 初始化控制器高度 ==== Strat ====
        let boxHeight = $(`#${videojsid.value}`).height();
        let videoHeight = $(`#${videojsid.value}_html5_api`).height();

        $('#controls-footer').css('bottom', `${boxHeight - videoHeight}px`);
        // 初始化控制器高度 ==== End ====
      });
    }   
    function initVideoJS(){
      $('.vjs-text-track-display').remove();
      $('.vjs-loading-spinner').remove();
      $('.vjs-big-play-button').remove();
      $('.vjs-control-bar').remove();
      $('.vjs-error-display').remove();
      $('.vjs-modal-dialog').remove();
      $(`#${videojsid.value}_html5_api`).addClass('w-100 h-100');
        
      $('#videoControls').on({
        mousemove: function () {
          if(isShow.value == false){
            isShow.value = true;
          }
          if(videoControlsTimeout.value){
            clearTimeout(videoControlsTimeout.value);
          }
        },
        mousemoveend: function () {
          // console.log("mousemoveend");
          if(isShow.value === true && isPlaying.value === true){
            isShow.value = false;
          }
          if(videoControlsTimeout.value){
            clearTimeout(videoControlsTimeout.value);
          }
        },
        touchstart: function () {
          if(isShow.value == false){
            isShow.value = true;
          }
          if(videoControlsTimeout.value){
            clearTimeout(videoControlsTimeout.value);
          }
        },
        touchmove: function () {
          if(isShow.value == false){
            isShow.value = true;
          }
          if(videoControlsTimeout.value){
            clearTimeout(videoControlsTimeout.value);
          }
        },
        mouseleave: function () {
          videoControlsTimeout.value = setTimeout( () => {
            if(isPlaying.value == true){
              isShow.value = false;
            }
          } , 300);
        },
        touchend: function () {
          videoControlsTimeout.value = setTimeout( () => {
            if(isPlaying.value == true){
              isShow.value = false;
            }
          } , 300);
        },
        touchcancel: function () {
          videoControlsTimeout.value = setTimeout( () => {
            if(isPlaying.value == true){
              isShow.value = false;
            }
          } , 300);
        }
      });
    } 
    function onVideoReady(){   
      // console.log("onVideoReady");
      if(ready.value && ready.value != undefined && typeof ready.value === 'function'){ 
        ready.value();
      }
    }
    function onVideoCanplaythrough(){
      if(canplaythrough.value && canplaythrough.value != undefined && typeof canplaythrough.value === 'function'){ 
        canplaythrough.value();
      }
      if(lastcurrenttime.value != null){
        if(refVideoJS.value){
          refVideoJS.value.setPlaySeekToTime(lastcurrenttime.value);
        }
        lastcurrenttime.value = null;
      }
    }
    function onVideoEnded(){
      if(end.value && end.value != undefined && typeof end.value === 'function'){ 
        end.value();
      }
    }
    function onVideoError(){
      console.log("onVideoError: ", error.value);
      if(error.value && error.value != undefined && typeof error.value === 'function'){ 
        error.value();
      }
    }
    function onPlayStatusChange(){
      if(refVideoJS.value){
        let isPlay = refVideoJS.value.isPlaying();

        if(isPlay == true){
          refVideoJS.value.pause();
        }else{
          refVideoJS.value.play();
          videoControlsTimeout.value = setTimeout( () => {
            if(isPlaying.value == true){
              isShow.value = false;
            }
          } , 300);
        }
      }
    }
    function playerStatusChange(state){
      if(state){
        if(state.playing == true){
          isPlaying.value = true;
        }else if(state.paused == true){
          isPlaying.value = false;
          isShow.value = true;
        }
      }else{
        // console.log('player status change fail.');
      }
    }
    function onVideoFullscreenchange(isFull){
      isFullScreen.value = isFull;
      if(isFull == true){
        $('#controls-footer').css('bottom', '0');
      }else{
        let boxHeight = $(`#${videojsid.value}`).height();
        let videoHeight = $(`#${videojsid.value}_html5_api`).height();

        $('#controls-footer').css('bottom', `${boxHeight - videoHeight}px`);
      }
      if(isPlaying.value == true){
        videoControlsTimeout.value = setTimeout( () => {
          if(isPlaying.value == true){
            isShow.value = false;
          }
        } , 300);
      }
    }
    function onVideoDurationchange(time){
      totalTime.value = Math.floor(time);
      // console.log('totalTime.value',totalTime.value);
      totalTimeMMSS.value = toMMSS(totalTime.value);
      if(refVideoSlider.value){
        refVideoSlider.value.noUiSlider.updateOptions({
          range: {
            'min': [0],
            'max': [totalTime.value]
          }
        });
      }
    }
    function onPlayStop(){
      if(refVideoJS.value){
        refVideoJS.value.pause();
      }
    }
    function onVideoTimeupdate(time, isSlider){
      if(isVideoSlider.value == false || isSlider == true){
        currentTime.value = Math.floor(time);
        currentTimeMMSS.value = toMMSS(currentTime.value);
      }  
      if(videoTimeupdate.value && videoTimeupdate.value != undefined && typeof videoTimeupdate.value === 'function'){
        videoTimeupdate.value(time);
      }
    }
    function onChangeMuted(){
      if(refVideoJS.value){
        let muted = refVideoJS.value.getMuted();

        if(volume.value <= 0){
          if(muted == false){
            refVideoJS.value.setMuted(true);
            isMuted.value = true;
          }else if(mutedVolume.value > 0){
            volume.value = mutedVolume.value;
            refVolumeSlider.value.noUiSlider.set(volume.value);
            refVideoJS.value.setMuted(!isMuted.value);
            isMuted.value = !isMuted.value;
          }
        }else if(inapp.value.isMobile){
          refVideoJS.value.setMuted(!isMuted.value);
          isMuted.value = !isMuted.value;
        }else{
          if(muted == false){
            mutedVolume.value = volume.value;
            volume.value = 0;
          }else{
            volume.value = mutedVolume.value;
          }
          refVolumeSlider.value.noUiSlider.set(volume.value);
          refVideoJS.value.setMuted(!isMuted.value);
          isMuted.value = !isMuted.value;
        }
      }
    }
    function onFullscreenchange(){
      if(refVideoJS.value){
        if(isFullScreen.value == true){
          refVideoJS.value.onExitFullscreen();
        }else{
          isFullPlaying.value = isPlaying.value;
          refVideoJS.value.onFullscreen();
        }
      }
    }
    function onChangePlaybackRate(value){
      playbackRate.value = value;
      if(refVideoJS.value){
        refVideoJS.value.setPlaybackRate(value);
      }
    }
    function onChangeResolution(item){
      if(changeResolution.value && changeResolution.value != undefined && typeof changeResolution.value === 'function'){
        changeResolution.value(item, currentTime.value);
      }
    }
    function onChangeLastcurrenttime(value){
      lastcurrenttime.value = value;
    }
    function toMMSS(second){   
      if (!isNaN(second)){
        let minutes = Math.floor(second / 60);

        second -= minutes*60;
        if (minutes < 10) { minutes = '0'+minutes; }
        if (second < 10) { second = '0'+second; }
        return minutes+':'+second;                
      }
      return '00:00';
    }
    return {
      // ref
      refVideoJS, //播放器
      refVideoSlider, //影片進度條
      refVolumeSlider, //音量條
      // const data
      videojsid,
      inapp, //檢查是否為手機的工具
      isTeleport, //搬移開關
      isPlaying, //播放狀態
      isFullPlaying, //全螢幕前播放狀態
      isMuted, //靜音狀態
      isVideoSlider, //滑動影片進度條狀態
      isFullScreen, //全螢幕狀態
      isShow, //控制器顯示狀態
      totalTime, //影片總時數
      totalTimeMMSS, //影片總時數顯示用
      currentTime, //影片當前時間
      currentTimeMMSS, //影片當前時間顯示用   
      volume, //影片音量    
      mutedVolume, //影片靜音時音量
      playbackRate, //影片播放速率  
      videoResolution, //影片解析度    
      videoControlsTimeout, //控制器隱藏監聽器
      lastcurrenttime, //最後播放時間
      // function event
      onVideoJSMounted, //VideoJS建置完畢事件
      onVideoTimeupdate, //更新影片事件
      playerStatusChange, //播放狀態切換事件
      onVideoReady, //影片準備完畢事件
      onVideoDurationchange, //影片總時數更新事件
      onVideoFullscreenchange, //全螢幕狀態切換事件
      onVideoCanplaythrough, //可播放緩衝完事件
      onVideoError, //影片讀取異常事件
      onVideoEnded, //影片播放完畢事件
      // function
      initVideoJS,
      onPlayStatusChange, //觸發切換播放狀態
      onPlayStop, //關閉播放狀態
      onChangeMuted, //觸發切換靜音狀態
      onFullscreenchange, //觸發切換全螢幕狀態
      onChangePlaybackRate, //觸發切換播放速率
      onChangeResolution, //觸發切換解析度
      onChangeLastcurrenttime, //觸發切換最後播放時間
    };
  },
};
</script>

<style scoped>

.v-enter-active,
.v-leave-active {
    transition: opacity 1s;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
.v-enter-to,
.v-leave-from {
    opacity: 1;
}
.noUi-handle { border:0px; }

.noUi-horizontal:hover {
    height: 8px;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
    transform: scale(1.2);
}

* {
  -webkit-touch-callout:none; /*系統默認選單禁用*/
  -webkit-user-select:none;   /*webkit瀏覽器選單禁用*/
  -khtml-user-select:none;    /*早期瀏覽器選單禁用*/
  -moz-user-select:none;      /*火狐瀏覽器選單禁用*/
  -ms-user-select:none;       /*IE10瀏覽器選單禁用*/
  user-select:none;           /*瀏覽器選單禁用*/
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

a:focus,
div:focus{
  outline:none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

/* video custom styles */


.btn-play {
  border-radius: 50%;
  background-color: #fff;
  border: none;
  box-shadow: 0 2px 6px 0 rgba(136,148,171,.2),0 24px 20px -24px rgba(71,82,107,.1);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='%2322244a' stroke='%2322244a' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play'%3E%3Cpolygon points='5 3 19 12 5 21 5 3'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}


.video-info-text {
 width: calc(100% - 40px);
  
  p { margin: 0; }
}

.video-name, .video-subtext {
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  &.medium {
    font-size: 14px;
    line-height: 24px;
  }
  
  &.tiny {
    font-size: 12px;
    line-height: 16px;
  }
}

.video-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.video-subtext { opacity: .8; }

.video-time {
  position: absolute;
  z-index: 1;
/*
  border-radius: 10px;
  padding: 4px 12px;
  background-color: rgba(139, 156, 163, .5);
  font-size: 10px;
*/
  right: 12px;
  top: 12px;
  color: #fff;
}

.heart{
    font-size: 22px;
}
.videoicon{
    font-size: 18px;
}
.videofont{
    font-size: 12px;
    line-height: 1.3;
}
.videofontlh{
   font-size: 12px;
    line-height: 1;    
}
@media screen and (max-width: 1100px) {
.videofont{
    font-size: 14px;
}} 
@media screen and (max-width: 700px) {
.videoicon{
    font-size: 14px;
} 
.videofont{
    font-size: 13px;
    line-height: 1.2;
}
.videofontlh{
    font-size: 13px;
}
.videospeed{
    width: 30px;
}
}
.videospeed{
    width: 60px;
}
.text-neutral {
    color: #ffffff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
    color: #d9d9d9 !important;
}


/* The container <div> - needed to position the dropup content */
  .dropup {
  position: relative;
  display: inline-block;
}

/* Dropup content (Hidden by Default) */
.dropup-content {
  display: none;
  position: absolute;
  right:0px;
  bottom: 30px;
  background-color: #f1f1f1;
  min-width: 100px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 101;
}

.valuec { 
  left:35px;
  bottom: 6px;
  background-color: rgba(0,0,0,0);
  min-width: 100px;
}


/* Links inside the dropup */
.dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropup links on hover */
.dropup-content a:hover {background-color: #ddd}

/* Show the dropup menu on hover */
.dropup:hover .dropup-content {
  display: block;
}

/* Change the background color of the dropup button when the dropup content is shown */
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.playersmall{
    width: 50px;
    height: 50px;
}
.player{
    width: 60px;
    height: 60px;
    font-size: 23px;
}
@media screen and (max-width: 780px) {
.player{
    width: 50px;
    height: 50px;
    font-size: 18px;
} 
.playersmall{
    width: 45px;
    height: 45px;
}
}
@media screen and (max-width: 780px) {
    .bg-md-soft{
        background-color: #f5f9fe;
    }    
}
@media screen and (max-width: 780px) {
.border-md-0{
    border:0 !important;
    }}


    .testbar{
    width: 17%;
    height: 56px;
}
.testbarcard{
     width: 20%;
    height: 50px;
}


.testbar{
    width: 63px;
    height: 56px;
}


.levelimg{
    width: 120px;
    height: 120px;
    object-fit: cover;
}
.qnsimg{
    width: 100px;
    height: 100px;
    object-fit: cover;
}
.testlist{
    width: 70px;
    height: 56px;
}
.testlist2{
    width: 54px;
    height: 56px;
}


.testchooiceimg{
height: 200px;
object-fit: contain;
}

.abcd{min-width: 40px;}


.content::-webkit-scrollbar { 
  display: none;
}

.whitenormal{
    white-space: normal;
}
.tablebreak{
     white-space: normal;
}

@media screen and (max-width: 700px) {
.tablebreak{
     white-space: nowrap;
}}

@media screen and (min-width: 1700px) {
.float-right-xxl{
     float: right !important;
}}

@media (min-width: 992px) {
    .videoheight{
        height: 405px;
    }}
@media (min-width: 1200px) {
    .videoheight{
        height: 480.94px;
    }}
@media (min-width: 1400px) {
    .videoheight{
        height: 33.8vw;
    }}
@media (min-width: 1600px) {
    .videoheight{
        height: 29.55vw;
    }}


.d-text-white{
    color: #fff;
    font-size: 5rem;
    font-weight: 700;
    z-index: 1;
    bottom: -40px;
    left: -10px; 
    opacity: .2;
}
.d-text-green{
    color: #e0f3fc;
}
.d-text-purple{
    color: #f6f0fc;
}
.d-text-warning{
    color: #fffbeb;

}

.w-week{width: 14.285%}


.Rectangle {
  width: 20px;
  height: 4px;
  margin: 9px 0 0;
  border-radius: 1.8px;
  background-color: #ea525e;
}

.bg-gold{
    background-color: #cca967;
}

.qnsicon{
    width: 20px;
}

.dele button{
    opacity: 0;}
.dele:hover button{
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}


.videotitle{
    font-family: "Roboto Slab", "Times New Roman";
    font-weight:700;
}
.header-filter {
  position: relative; }
  .header-filter:before, .header-filter:after {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: block;
    left: 0;
    top: 0;
    content: ""; }
  .header-filter::before {
    background: rgba(0, 0, 0, 0.5); }
  .header-filter .container {
    z-index: 2;
    position: relative; }

.radarclass{
    width: 33.3%;
}
@media (min-width: 700px) {
.radarclass{
    width: 20%;
}}


.loading{
            width: 80px;
            height: 40px;
            margin: 0 auto;
            margin-bottom:50px;
        }
        .loading span{
            display: inline-block;
            width: 8px;
            height: 100%;
            border-radius: 4px;
            background: lightgreen;
            -webkit-animation: load 1s ease infinite;
        }
        @-webkit-keyframes load{
            0%,100%{
                height: 40px;
                background: lightgreen;
            }
            50%{
                height: 70px;
                margin: -15px 0;
                background: lightblue;
            }
        }
        .loading span:nth-child(2){
            -webkit-animation-delay:0.2s;
        }
        .loading span:nth-child(3){
            -webkit-animation-delay:0.4s;
        }
        .loading span:nth-child(4){
            -webkit-animation-delay:0.6s;
        }

/*
.pointorange{
    position:absolute;
    bottom: 12%;
    font-size: 5px !important;
   left: 46%;
}
*/
.pointorange{
    display: block;
    position: absolute;
    top: -8px;
    right: -5px;
    border-radius: 50rem;
    background-color: #ffa600;
    width: 5px;
    height: 5px;
}
.pointorange2{
    display: block;
    position: absolute;
    bottom:5px;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%) ;
    border-radius: 50rem;
    background-color: #ffa600;
    width: 5px;
    height: 5px;
}
.pointorange1{
    display: block;
    position: absolute;
    bottom:5px;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%) ;
    border-radius: 50rem;
    background-color: #ffa600;
    width: 5px;
    height: 5px;
}

.messagered{
    margin-top: 10px;
    display: block;
    border-radius: 5rem;
    background-color: #ea525e;
    width: 5px;
    height: 5px;
}
.loading1 {
  font-size: 24px;
  font-weight: 800;
  text-align: center;
}
.loading1 span {
  display: inline-block;
  margin: 0 -0.05em;
}
/* code #3 */
.loading03 span {
  margin: 0 -0.075em;
  animation: loading03 1s infinite alternate;
}
.loading03 span:nth-child(2) {
  animation-delay: 0.2s;
}
.loading03 span:nth-child(3) {
  animation-delay: 0.4s;
}
.loading03 span:nth-child(4) {
  animation-delay: 0.6s;
}
.loading03 span:nth-child(5) {
  animation-delay: 0.8s;
}
.loading03 span:nth-child(6) {
  animation-delay: 1.0s;
}
.loading03 span:nth-child(7) {
  animation-delay: 1.2s;
}
.loading03 span:nth-child(8) {
  animation-delay: 1.4s;
}
.loading03 span:nth-child(9) {
  animation-delay: 1.6s;
}
.loading03 span:nth-child(10) {
  animation-delay: 1.8s;
}
.loading03 span:nth-child(11) {
  animation-delay: 2.0s;
}
.loading03 span:nth-child(12) {
  animation-delay: 2.2s;
}


@keyframes loading03 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}
/* code #4 */
.loading04 span {
  margin: 0 -0.075em;
  animation: loading04 1.5s infinite alternate;
}
.loading04 span:nth-child(2) {
  animation-delay: 0.1s;
}
.loading04 span:nth-child(3) {
  animation-delay: 0.2s;
}
.loading04 span:nth-child(4) {
  animation-delay: 0.3s;
}
.loading04 span:nth-child(5) {
  animation-delay: 0.4s;
}
.loading04 span:nth-child(6) {
  animation-delay: 0.5s;
}
.loading04 span:nth-child(7) {
  animation-delay: 0.6s;
}
.loading04 span:nth-child(8) {
  animation-delay: 0.7s;
}
.loading04 span:nth-child(9) {
  animation-delay: 0.8s;
}
.loading04 span:nth-child(10) {
  animation-delay: 0.9s;
}
.loading04 span:nth-child(11) {
  animation-delay: 1.0s;
}
.loading04 span:nth-child(12) {
  animation-delay: 1.1s;
}
.loading04 span:nth-child(13) {
  animation-delay: 1.2s;
}
.loading04 span:nth-child(14) {
  animation-delay: 1.3s;
}
.loading04 span:nth-child(15) {
  animation-delay: 1.4s;
}
.loading04 span:nth-child(16) {
  animation-delay: 1.5s;
}
.loading04 span:nth-child(17) {
  animation-delay: 1.6s;
}

@keyframes loading04 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}
.load1 {
  position: relative;
  margin: 50px auto;
  width: 100px;
  height: 80px;
}

.gear {
  position: absolute;
  z-index: -10;
  width: 40px;
  height: 40px;
  animation: spin 5s infinite;
}

.two {
  left: 40px;
  width: 80px;
  height: 80px;
  animation: spin-reverse 5s infinite;
}

.three {
  top: 45px;
  left: -10px;
  width: 60px;
  height: 60px;
}

@keyframes spin {
  50% {
    transform: rotate(360deg);
  }
}

@keyframes spin-reverse {
  50% {
    transform: rotate(-360deg);
  }
}

.lil-circle {
  position: absolute;
  border-radius: 50%;
  box-shadow: inset 0 0 10px 2px gray, 0 0 50px white;
  width: 100px;
  height: 100px;
  opacity: .65;
}

.blur-circle {
  position: absolute;
  top: -19px;
  left: -19px;
}
.text1 {
  color: lightgray;
  font-size: 18px;
  font-family: "Open Sans", sans-serif;
  text-align: center;
}
.ed-po{    
    position: absolute;
    left: 7px;
    top: 4px;}

@keyframes upAnimation {
    0% {
        transform: rotate(0deg);
        transition-timing-function: cubic-bezier(0.215, .61, .355, 1)
    }

    10% {
        transform: rotate(-12deg);
        transition-timing-function: cubic-bezier(0.215, .61, .355, 1)
    }

    20% {
        transform: rotate(12deg);
        transition-timing-function: cubic-bezier(0.215, .61, .355, 1)
    }

    28% {
        transform: rotate(-10deg);
        transition-timing-function: cubic-bezier(0.215, .61, .355, 1)
    }

    36% {
        transform: rotate(10deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    42% {
        transform: rotate(-8deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    48% {
        transform: rotate(8deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    52% {
        transform: rotate(-4deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    56% {
        transform: rotate(4deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    60% {
        transform: rotate(0deg);
        transition-timing-function: cubic-bezier(0.755, .5, .855, .06)
    }

    100% {
        transform: rotate(0deg);
        transition-timing-function: cubic-bezier(0.215, .61, .355, 1)
    }
}
.giftnum{
    position: absolute;
    top: 8px;
    left: 8px;
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    color: white;
    background-color: #34b8c6;
    font-size: 13px;
    padding-top: 3px;
    font-weight: 600;
}

.break-all{
    word-break: break-all;
}


.talkw{   
    max-width: 33.3333%;
   
}
@media (max-width: 768px) {
.talkw{
     max-width: 41.66667%;
}}

.wrapper {
 min-height: calc(100vh - 241px);
}
@media (max-width: 600px) {
    .wrapper {
 min-height: calc(100vh - 394px);
}}

.center-vertical-absolute,
.center-horizontal-absolute {
    position: absolute;
}

.center-vertical-absolute {
    top: 50%;
    transform: translateY(-50%);
}
@media only screen and (max-width: 768px) {
.center-vertical-absolute {
    top: 43%;
    transform: translateY(-50%);
}   
}
.center-horizontal-absolute {
    left: 50%;
    transform: translateX(-50%);
}

.position-absolute {
    position: absolute !important;
}

.left-0 {
    left: 0;
}

.mt-n4,
.my-n4 {
    margin-top: -1.5rem !important;
}

.rounded-pill {
    border-radius: 50rem !important;
}

.d-flex {
    display: flex !important;
}

.align-items-center {
    align-items: center !important;
}

.pl-1,
.px-1 {
    padding-left: 0.25rem !important;
}

.bg-gray-800 {
    background-color: rgba(0, 0, 0, 0.6) !important;
}

a.bg-gray-800:hover, a.bg-gray-800:focus,
button.:hover,
button.bg-gray-800:focus {
    background-color: #3a3b5a !important;
}

.progress-info .bg-gray-800::after {
    border-top-color: #3a3a3a;
}

.rounded-right {
    border-top-right-radius: 0.45rem !important;
    border-bottom-right-radius: 0.45rem !important;
}
.rounded-right-0 {
    border-top-right-radius: 0rem !important;
    border-bottom-right-radius: 0rem !important;
}

.rounded-right-0-pad {
    border-top-right-radius: 0.45rem !important;
    border-bottom-right-radius: 0.45rem !important;
}.rounded-left-0-pad  {
    border-top-left-radius: 0.45rem !important;
    border-bottom-left-radius: 0.45rem !important;
}

.right-0 {
    right: 0;
}

.input-slider--cyan .noUi-connect {
    background: #17a2b8;
}

.input-slider--cyan.noUi-horizontal .noUi-handle,
.input-slider--cyan.noUi-vertical .noUi-handle {
    background-color: #17a2b8;
}

.input-slider--red .noUi-connect {
    background: #ea525e;
}

.input-slider--red.noUi-horizontal .noUi-handle,
.input-slider--red.noUi-vertical .noUi-handle {
    background-color: #ea525e;
}

.input-slider--green .noUi-connect {
    background: #208163;
}

.input-slider--green.noUi-horizontal .noUi-handle,
.input-slider--green.noUi-vertical .noUi-handle {
    background-color: #208163;
}

.input-slider--yellow .noUi-connect {
    background: #F0B400;
}

.input-slider--yellow.noUi-horizontal .noUi-handle,
.input-slider--yellow.noUi-vertical .noUi-handle {
    background-color: #F0B400;
}

.input-slider--pink .noUi-connect {
    background: #e83e8c;
}

.input-slider--pink.noUi-horizontal .noUi-handle,
.input-slider--pink.noUi-vertical .noUi-handle {
    background-color: #e83e8c;
}

.input-slider-value-output {
    background: #0d1b48;
    color: #ffffff;
    padding: 4px 8px;
    position: relative;
    top: 12px;
    font-size: 11px;
    border-radius: 2px;
}

.input-slider-value-output:after {
    bottom: 100%;
    left: 10px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: #0d1b48;
    border-bottom-color: #333;
    border-width: 4px;
    margin-left: -4px;
}

.input-slider-value-output.left:after {
    left: 10px;
    right: auto;
}

.input-slider-value-output.right:after {
    right: 10px;
    left: auto;
}

/* Range slider value labels */
.range-slider-value {
    font-size: 0.75rem;
    font-weight: 500;
    background-color: rgba(13, 27, 72, 0.7);
    color: #ffffff;
    border-radius: 10px;
    padding: .4em .8em .3em .85em;
}

.range-slider-wrapper .upper-info {
    font-weight: 400;
    margin-bottom: 5px;
}

.input-slider-value-output {
    background: #0d1b48;
    color: #ffffff;
    padding: 4px 8px;
    position: relative;
    top: 12px;
    font-size: 11px;
    border-radius: 2px;
}

.input-slider-value-output:after {
    bottom: 100%;
    left: 10px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: #0d1b48;
    border-bottom-color: #333;
    border-width: 4px;
    margin-left: -4px;
}

.input-slider-value-output.left:after {
    left: 10px;
    right: auto;
}

.input-slider-value-output.right:after {
    right: 10px;
    left: auto;
}

.d-none {
    display: none !important;
}

.d-md-block {
        display: block !important;
    }

.rounded-lg {
    border-radius: 0.45rem !important;
}

.btn-danger {
    color: #ffffff!important;
    background-color: #ea525e;
    border-color: #ea525e;
/*    box-shadow: 0 0 24px rgba(27, 22, 66, 0.04), 0 44px 74px rgba(27, 22, 66, 0.06);*/
}

.btn-danger:hover {
    color: #ffffff;
    background-color: #ff5764;
    border-color: #ea525e;
}

.btn-danger:focus, .btn-danger.focus {
    color: #ffffff;
    background-color: #ea525e;
    border-color: #f26570;
/*    box-shadow: 0 0 24px rgba(27, 22, 66, 0.04), 0 44px 74px rgba(27, 22, 66, 0.06), 0 0 0 0.25rem rgba(200, 72, 85, 0.5);*/
}

.btn-danger.disabled, .btn-danger:disabled {
    color: #ffffff;
    background-color: #aaaaaa;
    border-color: #aaaaaa;
}

.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
  .show > .btn-danger.dropdown-toggle {
    color: #ffffff;
    background-color: #e32c3b;
    border-color: #e32c3b;
}

.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
    .show > .btn-danger.dropdown-toggle:focus {
    box-shadow: none;
        outline: none;
}

.noUi-target,
.noUi-target * {
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-user-select: none;
    touch-action: none;
    -ms-user-select: none;
    user-select: none;
    box-sizing: border-box;
}

.noUi-target {
    position: relative;
    direction: ltr;
}

>>> .noUi-base,
>>> .noUi-connects {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
}

>>> .noUi-connect {
  background: #ea525e !important;
}

</style>